import { useEffect, useRef, useState } from "react";
import { Avatar } from "@jaiho/ui";
import { CHAT_MESSAGE_MAX_LENGTH } from "@jaiho/shared";
import { useAuth } from "../state/AuthContext";
import { useChat } from "../state/ChatContext";
import { PlayerProfileSheet } from "../components/PlayerProfileSheet";
import "./ChatScreen.css";

const timeFormatter = new Intl.DateTimeFormat("en-IN", { hour: "numeric", minute: "2-digit" });

export function ChatScreen() {
  const { me } = useAuth();
  const { connectionState, messages, presenceCount, sendMessage } = useChat();
  const [draft, setDraft] = useState("");
  const [openProfileUserId, setOpenProfileUserId] = useState<string | null>(null);
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    listRef.current?.scrollTo({ top: listRef.current.scrollHeight });
  }, [messages]);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!draft.trim()) return;
    sendMessage(draft);
    setDraft("");
  }

  return (
    <div className="jaiho-chat">
      <header className="jaiho-chat__header">
        <div>
          <div className="jaiho-chat__title">Jaiho91 Global Lobby</div>
          <div className="jaiho-chat__status">
            <span className={`jaiho-chat__status-dot jaiho-chat__status-dot--${connectionState}`} />
            {connectionState === "open" ? `${presenceCount} online` : connectionState}
          </div>
        </div>
      </header>

      <div className="jaiho-chat__list" ref={listRef}>
        {messages.map((m) => (
          <div key={m.id} className={`jaiho-chat__message${m.userId === me?.profile.userId ? " jaiho-chat__message--own" : ""}`}>
            <button
              type="button"
              className="jaiho-chat__avatar-button"
              onClick={() => setOpenProfileUserId(m.userId)}
              aria-label={`View ${m.displayName}'s profile`}
            >
              <Avatar name={m.displayName} src={m.avatarUrl} size={28} />
            </button>
            <div className="jaiho-chat__bubble">
              <div className="jaiho-chat__meta-row">
                <button type="button" className="jaiho-chat__author" onClick={() => setOpenProfileUserId(m.userId)}>
                  {m.displayName}
                </button>
                <span className="jaiho-chat__time">{timeFormatter.format(new Date(m.createdAt))}</span>
              </div>
              <div className="jaiho-chat__body">{m.body}</div>
            </div>
          </div>
        ))}
      </div>

      <form className="jaiho-chat__composer" onSubmit={handleSubmit}>
        <input
          className="jaiho-chat__input"
          value={draft}
          maxLength={CHAT_MESSAGE_MAX_LENGTH}
          placeholder="Say something…"
          onChange={(e) => setDraft(e.target.value)}
        />
        <button className="jaiho-chat__send" type="submit" disabled={!draft.trim()}>
          Send
        </button>
      </form>

      {openProfileUserId && (
        <PlayerProfileSheet userId={openProfileUserId} onClose={() => setOpenProfileUserId(null)} />
      )}
    </div>
  );
}
